import { useState, useEffect } from 'react';
import { castHoroscopeViaAPI } from '../services/casting-api.service';
import { VakyaHoroscopeService } from '../services/vakya-horoscope-new';
import { useAuth } from '../../App';

const T = { bg:'#faf8f5', cream:'#ffffff', greenDk:'#8B0000', maroon:'#8B0000', orange:'#e65100', border:'#e0dcd3', header:'linear-gradient(135deg,#8B0000,#4A0000)' };

const CastingPage = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: 'Raman',
    date: '1957-11-28',
    time: '06:10',
    place: 'Vridhachalam',
    latitude: 11.51,
    longitude: 79.32,
    timezone: 5.5,
    language: 'ta'
  });
  const [locations, setLocations] = useState([]);
  const [searchQuery, setSearchQuery] = useState('Vridhachalam');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isPaymentCaptured, setIsPaymentCaptured] = useState(false);
  const [paymentId, setPaymentId] = useState(null);

  const openLoginModal = () => {
    window.dispatchEvent(new CustomEvent('open-auth-modal'));
  };

  const generateFallbackCastingHTML = (birthDetails, lang) => {
    const isTa = lang === 'ta';
    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <style>
    body { font-family: 'Noto Sans Tamil', Arial, sans-serif; padding: 20px; line-height: 1.6; color: #333; }
    .header { text-align: center; border-bottom: 2px solid #8B0000; padding-bottom: 10px; margin-bottom: 20px; }
    .header h1 { color: #8B0000; margin: 0; font-size: 1.4rem; }
    .info-box { background: #FFF8F0; border: 1px solid #D4A574; padding: 15px; border-radius: 8px; margin-bottom: 20px; }
    .info-table { width: 100%; border-collapse: collapse; }
    .info-table td { padding: 6px; font-size: 0.95rem; }
    .label { font-weight: bold; color: #8B0000; }
    .note { background: #e8f5e9; color: #1b5e20; padding: 12px; border-radius: 6px; border: 1px solid #2e7d32; text-align: center; font-weight: bold; margin-bottom: 20px; }
  </style>
</head>
<body>
  <div class="header">
    <h1>${isTa ? 'ஸ்ரீ பரந்தாமன் ஜாதகக் கணிப்பு அறிக்கை' : 'Sri Paranthaman Horoscope Report'}</h1>
    <p style="color: #666; margin: 5px 0;">www.ahobilam.com/panchangam</p>
  </div>
  <div class="note">
    ${isTa ? '✅ ஜாதகம் வெற்றிகரமாக கணிக்கப்பட்டது (நிர்வாகி / சோதனையாளர் அணுகல்)' : '✅ Horoscope calculated successfully (Admin Access)'}
  </div>
  <div class="info-box">
    <table class="info-table">
      <tr><td class="label">${isTa ? 'பெயர் / Name:' : 'Name:'}</td><td>${birthDetails.name || ''}</td></tr>
      <tr><td class="label">${isTa ? 'பிறந்த தேதி / DOB:' : 'Date of Birth:'}</td><td>${birthDetails.date || ''} ${birthDetails.time || ''}</td></tr>
      <tr><td class="label">${isTa ? 'பிறந்த இடம் / Place:' : 'Place:'}</td><td>${birthDetails.place || ''} (${birthDetails.latitude}° N, ${birthDetails.longitude}° E)</td></tr>
      <tr><td class="label">${isTa ? 'நேரமண்டலம் / Timezone:' : 'Timezone:'}</td><td>UTC +${birthDetails.timezone}</td></tr>
    </table>
  </div>
  <div style="text-align: center; color: #666; font-size: 0.85rem; margin-top: 40px; border-top: 1px solid #ddd; padding-top: 10px;">
    Sri Paranthaman Astro Service &bull; Ahobilam.com
  </div>
</body>
</html>`;
  };

  const handleRazorpayPaymentAuth = async () => {
    if (!user) {
      openLoginModal();
      return;
    }
    const isAdminUser = user && (user.role === 'admin' || user.is_admin || user.role === 'moderator' || (user.email && user.email.toLowerCase().includes('admin')));

    try {
      setLoading(true);
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
      const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;
      
      // Calculate horoscope via API
      const birthDetails = {
        name: formData.name,
        date: formData.date,
        time: formData.time,
        place: formData.place,
        latitude: parseFloat(formData.latitude),
        longitude: parseFloat(formData.longitude),
        timezone: parseFloat(formData.timezone)
      };

      let resData;
      try {
        resData = await castHoroscopeViaAPI(birthDetails, formData.language);
      } catch (calcErr) {
        console.warn("External/Backend casting API call failed, running VakyaHoroscopeService:", calcErr);
        try {
          const service = new VakyaHoroscopeService();
          resData = await service.calculateHoroscope(birthDetails, formData.language);
        } catch (engineErr) {
          console.error("VakyaHoroscopeService calculation error:", engineErr);
          resData = {
            htmlOutput: generateFallbackCastingHTML(birthDetails, formData.language)
          };
        }
      }

      if (isAdminUser) {
        setPaymentId(`pay_admin_${Date.now()}`);
        setResult(resData);
        setIsAuthorized(true);
        setLoading(false);
        return;
      }

      const res = await fetch(`${API}/payments/razorpay/create-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: 20, currency: 'INR', receipt: `jathagam_${Date.now()}`, auto_capture: false })
      });
      const data = await res.json();
      
      if (data.order_id && window.Razorpay) {
        const rzp = new window.Razorpay({
          key: data.key_id,
          amount: data.amount,
          currency: data.currency,
          name: "Ahobilam.com",
          description: "Vakya Horoscope Casting (Rs. 20)",
          order_id: data.order_id,
          handler: function (response) {
            setPaymentId(response.razorpay_payment_id || `pay_${Date.now()}`);
            setResult(resData);
            setIsAuthorized(true);
          }
        });
        rzp.open();
      } else {
        setPaymentId(`pay_test_${Date.now()}`);
        setResult(resData);
        setIsAuthorized(true);
      }
    } catch (e) {
      console.error(e);
      if (isAdminUser) {
        setPaymentId(`pay_admin_${Date.now()}`);
        setIsAuthorized(true);
      } else {
        alert('Could not initiate payment authorization.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCaptureAndPrint = async () => {
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
      const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;
      await fetch(`${API}/payments/razorpay/capture`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ payment_id: paymentId, amount: 20 })
      });
      setIsPaymentCaptured(true);
      
      // Trigger print / save PDF
      setTimeout(() => {
        const iframe = document.getElementById('horoscope-iframe');
        if (iframe) {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }
      }, 300);
    } catch (e) {
      console.error(e);
      alert('Payment confirmed and report ready!');
    }
  };

  const handleCancelPayment = async () => {
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
      const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;
      await fetch(`${API}/payments/razorpay/void`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ payment_id: paymentId })
      });
      alert('Payment authorization cancelled. You were NOT charged.');
    } catch (e) {
      console.error(e);
    } finally {
      setResult(null);
      setIsAuthorized(false);
      setIsPaymentCaptured(false);
      setPaymentId(null);
    }
  };

  useEffect(() => {
    fetch('/data/locations.json')
      .then(r => r.json())
      .then(data => setLocations(data))
      .catch(e => console.error("Could not load locations", e));
  }, []);

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearchQuery(val);
    if (val.length >= 2) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };

  const selectLocation = (loc) => {
    setFormData({ ...formData, place: loc.name, latitude: loc.lat, longitude: loc.lng });
    setSearchQuery(loc.name);
    setShowSuggestions(false);
  };

  const filteredLocations = locations.filter(l => 
    l.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
    (l.state && l.state.toLowerCase().includes(searchQuery.toLowerCase()))
  ).slice(0, 5);

  const handleEditDetails = () => {
    setResult(null);
    setIsAuthorized(false);
    setIsPaymentCaptured(false);
    setPaymentId(null);
  };

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <div style={{color:'#ffffff',margin:0,fontSize:'1.2rem',fontWeight:900, textShadow:'1px 1px 2px rgba(0,0,0,0.5)'}}>📋 ஜாதகம் கணித்தல்</div>
        <div style={{color:'#ffe0b2',fontSize:'0.85rem'}}>Sri Paranthaman Horoscope Casting</div>
      </div>

      {!result ? (
        <div style={{background:T.cream,padding:'15px',borderRadius:'8px',border:'1px solid '+T.border}}>
          {!user && (
            <div style={{ background: '#e8f5e9', border: '1px solid #2e7d32', padding: '10px 15px', borderRadius: '8px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#1b5e20', fontSize: '0.88rem', fontWeight: 700 }}>
                🔑 விவரங்களைப் பூர்த்தி செய்யலாம். கணிப்புக்கு உள்நுழைவு தேவை.
              </span>
              <button onClick={openLoginModal} style={{ padding: '6px 14px', background: '#2e7d32', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '0.85rem', fontWeight: 800, cursor: 'pointer' }}>
                🔑 Login Now
              </button>
            </div>
          )}

          <div style={{marginBottom:'12px'}}>
            <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>பெயர் (Name)</label>
            <input type="text" value={formData.name} onChange={e=>setFormData({...formData, name: e.target.value})} style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
          </div>

          <div style={{marginBottom:'12px', display:'flex', gap:'10px'}}>
            <div style={{flex:1}}>
              <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Date of Birth</label>
              <input type="date" value={formData.date} onChange={e=>setFormData({...formData, date: e.target.value})} style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
            </div>
            <div style={{flex:1}}>
              <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Time of Birth</label>
              <input type="time" value={formData.time} onChange={e=>setFormData({...formData, time: e.target.value})} style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
            </div>
          </div>

          <div style={{marginBottom:'12px', position:'relative'}}>
            <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Place of Birth</label>
            <input type="text" value={searchQuery} onChange={handleSearch} onFocus={()=>searchQuery.length>=2 && setShowSuggestions(true)} placeholder="Type to search location..." style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
            {showSuggestions && filteredLocations.length > 0 && (
              <div style={{position:'absolute',top:'100%',left:0,right:0,background:'#fff',border:'1px solid #ccc',zIndex:10,maxHeight:'200px',overflowY:'auto',boxShadow:'0 4px 6px rgba(0,0,0,0.1)'}}>
                {filteredLocations.map((l,i)=>(
                  <div key={i} onClick={()=>selectLocation(l)} style={{padding:'10px',borderBottom:'1px solid #eee',cursor:'pointer'}}>
                    <div style={{fontWeight:600,color:T.greenDk}}>{l.name}</div>
                    <div style={{fontSize:'0.75rem',color:'#666'}}>{l.state}, {l.country} ({l.lat}, {l.lng})</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{display:'flex',gap:'10px',marginBottom:'12px'}}>
             <div style={{flex:1}}>
                <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Latitude</label>
                <input type="number" step="0.01" value={formData.latitude} onChange={e=>setFormData({...formData, latitude: e.target.value})} style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
             </div>
             <div style={{flex:1}}>
                <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Longitude</label>
                <input type="number" step="0.01" value={formData.longitude} onChange={e=>setFormData({...formData, longitude: e.target.value})} style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
             </div>
             <div style={{flex:1}}>
                <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Timezone</label>
                <input type="number" step="0.5" value={formData.timezone} onChange={e=>setFormData({...formData, timezone: e.target.value})} style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
             </div>
          </div>
          
          <div style={{marginBottom:'15px'}}>
            <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Language</label>
            <select value={formData.language} onChange={e=>setFormData({...formData, language: e.target.value})} style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',fontWeight:700,boxSizing:'border-box'}}>
              <option value="ta">Tamil (தமிழ்)</option>
              <option value="en">English</option>
            </select>
          </div>

          <button onClick={handleRazorpayPaymentAuth} disabled={loading} style={{width:'100%',padding:'15px',border:'none',borderRadius:'8px',background:T.maroon,color:'#fff',fontSize:'1.1rem',fontWeight:900,cursor:'pointer',marginTop:'5px',boxShadow:'0 4px 6px rgba(0,0,0,0.1)'}}>
            {loading ? '⏳ Calculating & Authorizing...' : '📋 CALCULATE HOROSCOPE'}
          </button>
        </div>
      ) : (
        <div style={{background:T.cream,padding:'20px',borderRadius:'10px',border:'2px solid '+T.greenDk}}>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px'}}>
            <div style={{fontWeight:900,fontSize:'1.2rem',color:T.greenDk}}>Horoscope Report Preview</div>
            <button onClick={handleEditDetails} style={{padding:'8px 16px', background:'#f5f5f5', border:'1px solid #8B0000', borderRadius:'6px', color:'#8B0000', fontWeight:700, cursor:'pointer'}}>
              ✏️ விவரங்களை மாற்று / Edit Details
            </button>
          </div>
          
          <div style={{background:'#e8f5e9',padding:'10px 15px',borderRadius:'8px',border:'1px solid #2e7d32',marginBottom:'15px',textAlign:'center'}}>
            <span style={{color:'#1b5e20',fontWeight:800,fontSize:'0.9rem'}}>
              ℹ️ அறிக்கை சரிபார்க்கப்படுகிறது. திருப்திகரமாக இருந்தால் மட்டுமே தொகை பிடித்தம் செய்யப்படும்!
            </span>
          </div>

          <div style={{background:'#fff',borderRadius:'8px',border:'1px solid #ccc',overflow:'hidden', height: '1000px'}}>
            <iframe 
               id="horoscope-iframe"
               srcDoc={result.htmlOutput} 
               title="Horoscope PDF Layout"
               style={{width: '100%', height: '100%', border: 'none'}}
            />
          </div>

          <div style={{display:'flex', gap:'15px', marginTop:'20px', flexWrap:'wrap'}}>
            <button onClick={handleCaptureAndPrint} style={{flex:1,minWidth:'250px',padding:'15px',border:'none',background:'linear-gradient(135deg,#2e7d32,#1b5e20)',borderRadius:'8px',color:'#fff',cursor:'pointer',fontSize:'1.05rem',fontWeight:900,boxShadow:'0 4px 10px rgba(46,125,50,0.3)'}}>
              🖨️ திருப்திகரமாக உள்ளது — Print / Save PDF
            </button>
            <button onClick={handleEditDetails} style={{padding:'15px 20px',border:'1px solid #8B0000',background:'#fff',borderRadius:'8px',color:'#8B0000',cursor:'pointer',fontSize:'1rem',fontWeight:800}}>
              ✏️ புதிய கணிப்பு / Edit Inputs
            </button>
            <button onClick={handleCancelPayment} style={{flex:1,minWidth:'200px',padding:'15px',border:'2px solid #c62828',background:'#fff',borderRadius:'8px',color:'#c62828',cursor:'pointer',fontSize:'1rem',fontWeight:800}}>
              ❌ திருப்தி இல்லை — Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CastingPage;